export const toDigits = (phoneNumber: string): string => {
  // Remove all non-digit characters
  let cleanedNumber = phoneNumber.replace(/\D+/g, '');

  return cleanedNumber;
};
